import React, { useEffect, useState } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import CKEditor from 'ckeditor4-react';
import { NotificationManager } from 'react-notifications';
import { Fecha, formatBytes, iconos, addAttachment, sendForwardMail } from '../../funciones/EmailFunction';

CKEditor.editorUrl = 'ckeditor/ckeditor.js';

const ForwardEmail = (props) => {
    const [destEmail, setDestEmail] = useState("");
    const [asunto, setAsunto] = useState(`Fwd: ${props.contenido.Title}`);
    const [contentState, setContentState] = useState();
    const [control, setControl] = useState(false);
    const [boton1, setBoton1] = useState({ icon: "fa fa-mail-forward", text: "Reenviar", disabled: false });
    const [boton2, setBoton2] = useState({ icon: "fa fa-paperclip", text: "Adjuntar Archivo" });
    const [destinatarios, setDestinatarios] = useState([]);
    const [tam, setTam] = useState(0);
    const [attFileName, setAttFileName] = useState([]);
    const [attFileNameOr, setAttFileNameOr] = useState(props.adjuntos);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);

    useEffect(() => {
        let f = new Date(props.contenido.Date);
        let meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        let hours = f.getHours()
        let minutes = f.getMinutes()
        let ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        let tamAdjOriginales = 0;

        let sender = (props.contenido.Sender).replace('<', ' - [')
        sender = sender.replace('>', ']')
        setContentState (`<div>
                            <br/>
                            <div align="center">----------- Mensaje Reenviado -----------<div>
                            <div><strong>Asunto:</strong> ${props.contenido.Title}</div>
                            <div><strong>Fecha:</strong> ${f.getDate()} de ${meses[f.getMonth()]} de ${f.getFullYear()}, ${hours}:${minutes} ${ampm}</div>
                            <div><strong>De:</strong> ${sender}</div>
                            <div><strong>Para:</strong> ${props.Remitente.label}</div>
                            <div align="center">--------------------------------------------------<div>
                            <div style="margin-left: 10px; border-left: 1px solid #9A9A9A">${props.Mess}</div>
                          </div>`
        )
        
        if ((attFileNameOr).length !== 0){
            attFileNameOr.map(option => {
                tamAdjOriginales += option.Bytes
            })
        }

        setTam(tam + tamAdjOriginales)
    }, []);

    let styles2 = {
        paddingRight: 15,
        cursor: "pointer",
        fontSize: 16,
        color: "f6a72f"
    }

    const configuraciones = {
        toolbar: [
            [ 'Font', 'FontSize', '-', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo', '-', 'Bold', 'Italic', 'Underline', '-', 'TextColor', 'BGColor', '-', 'Link', 'Maximize' ],
        ],
        height: "21vh",
        removePlugins: 'elementspath',
        /* removePlugins: 'resize, elementspath', */
    }

    let cambiaHtml = (e) => {
        setContentState(e.editor.getData())
    }

    let tipoDest = (tipo) => {
        switch (tipo) {
            case "D": return null
            case "C": return "CC: "
            case "CO": return "CCO: "
        }
    }

    let addDestinatario = (e) => {
        if (e.which === 13){
            let string = (e.target.value).trim();
            if (string === "") return null;

            const resultado = destinatarios.find( item => item.email === e.target.value );
            if (resultado === undefined){
                let contenido = destinatarios;
                let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
                (expReg.test(string) === false) ? contenido.push({ tipo:"D", email: destEmail, color: "cb0b0b"}) : contenido.push({ tipo:"D", email: destEmail, color: "6c7c9c"});
                
                setDestinatarios(contenido)
            }

            setControl(!control)
            setDestEmail("")
        }
    }

    let addOtDestinatario = (tipoD) => () => {
        let string = (destEmail).trim();
        if (string === "") return null;
        
        let contenido = destinatarios;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
        (expReg.test(string) === false) ? contenido.push({ tipo: tipoD, email: destEmail, color: "cb0b0b"}) : contenido.push({ tipo: tipoD, email: destEmail, color: "6c7c9c"});
        
        setDestinatarios(contenido)
        setControl(!control)
        setDestEmail("")
    }

    let addAttState = (item) => {
        let contenido = attFileName;
        contenido.push(item)

        setTam(tam + item[2])
        setAttFileName(contenido)
        setControl(!control)
    }

    let delAttachment = (adj) => {
        let contenido = attFileName;
        let size = 0;
        for (let i in attFileName){
            if (adj === attFileName[i][3]) contenido.splice(i, 1)
            if (attFileName[i] !== undefined) size += attFileName[i][2]
        }

        for (let i in attFileNameOr){
            if (attFileNameOr[i] !== undefined) size += attFileNameOr[i].Bytes
        }

        let file = document.getElementById(adj);
        if (file) {
            (file.parentNode).removeChild(file);
        }
        
        setTam(size)
        setAttFileName(contenido)
        setControl(!control)
    }

    let delAttachmentOr = (adj) => {
        let contenido = attFileNameOr;
        let size = 0;
        for (let i in attFileNameOr){
            if (adj === attFileNameOr[i]) contenido.splice(i, 1)
            if (attFileNameOr[i] !== undefined) size += attFileNameOr[i].Bytes
        }

        for (let i in attFileName){
            if (attFileName[i] !== undefined) size += attFileName[i][2]
        }

        setTam(size)
        setAttFileNameOr(contenido)
        setControl(!control)
    }

    let adjuntos = () => {
        let adjuntosOriginales = [];
        let nuevosAdjuntos = [];

        if (attFileName.length !== 0){
            attFileName.map(option => {
                nuevosAdjuntos.push(
                    <div key = {(Math.random() * 999999) + 1} className="attachment-file" style={{fontSize: 10, marginTop: 4, cursor: "default"}}>
                        <i className={iconos(option[1].toUpperCase(), "icono")} style={{color: iconos(option[1].toUpperCase(), "color")}}></i> {option[0]}
                        <div className="text-muted" align="right">({formatBytes(option[2])}) <i className="fa fa-trash text-danger" style={{fontSize: 12, cursor: "pointer"}} onClick={() => {delAttachment(option[3])}} title="Quitar este archivo"></i></div>
                    </div>
                )
            })
        }

        if (attFileNameOr.length !== 0){
            attFileNameOr.map(option => {
                adjuntosOriginales.push(
                    <div key = {(Math.random() * 999999) + 1} className="attachment-file" style={{fontSize: 10, marginTop: 4, cursor: "default"}}>
                        <i className={iconos(option.Subtype.toUpperCase(), "icono")} style={{color: iconos(option.Subtype.toUpperCase(), "color")}}></i> {option.Name}
                        <div className="text-muted" align="right">({formatBytes(option.Bytes)}) <i className="fa fa-trash text-danger" style={{fontSize: 12, cursor: "pointer"}} onClick={() => {delAttachmentOr(option)}} title="Quitar este archivo"></i></div>
                    </div>
                )
            })
        }

        if (attFileName.length === 0 && attFileNameOr.length === 0) return (
            <div align="center" className="text-muted" style={{fontSize: 11}}>Ningún archivo</div>
        )
        
        return (
            <React.Fragment>
                <div>{nuevosAdjuntos}</div>
                <div>{adjuntosOriginales}</div>
            </React.Fragment>
        )
    }

    let para = () => {
        if (destinatarios.length === 0 ) return (
            <div className="text-muted">Sin Destinatarios</div>
        )
        
        let borrar = (email) => {
            let contenido = destinatarios;

            for (let i in destinatarios){
                if (destinatarios[i].email === email) contenido.splice(i, 1)
            }

            setDestinatarios(contenido)
            setControl(!control)
        }

        return (
            destinatarios.map(option => (
                <span key = {(Math.random() * 999999) + 1} className="tagsinput" style={{backgroundColor: option.color}}>{tipoDest(option.tipo)}{option.email} <i className="fa fa-times" onClick={() => {borrar(option.email)}} title="Eliminar" style={{cursor: "pointer"}}></i></span>
            ))
        )
    }

    let tipos = (
        <Popover id="tipos">
            <div className="new-mail-item" onClick={addOtDestinatario("D")}>Destinatario</div>
            <div className="new-mail-item" onClick={addOtDestinatario("C")}>CC</div>
            <div className="new-mail-item" onClick={addOtDestinatario("CO")}>CCO</div>
        </Popover>
    )

    let contenidoMail = () => (
        <Row>
            <Col md={6}>
                <span className="text-muted" style={{fontSize: 10}}>Para:</span>
                <div className="input-group">
                    <input type="text" className="form-control" onChange={(e)=> {setDestEmail((e.target.value).trim())}} value={destEmail}
                    onKeyPress={ addDestinatario } title="Presiona ENTER para añadir un nuevo destinatario" placeholder="Para"/>
                    <div className="input-group-btn">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={tipos}>
                            <button className="btn btn-default" title="Agregar como" style={{height: 40}}><i className="fa fa-plus" style={{color: "005d9b"}}></i></button>
                        </OverlayTrigger>
                    </div>
                </div>
            </Col>
            <Col md={6}>
                <span className="text-muted" style={{fontSize: 10}}>Asunto:</span>
                <input type="text" className="form-control" placeholder="Asunto" value={asunto} onChange={(e) => {setAsunto(e.target.value)}}/>
            </Col>
            <Col md={12} className="custom-mt-10" style={{backgroundColor:"f2f4f8", overflowX:"hidden", overflowY: "auto", height: "8vh", padding: 5}}>
                {para()}
            </Col>
            <Col md={12} style={{padding: 6, paddingTop: 3}}>
                <div className="new-mail-body">
                    <CKEditor
                        data = {contentState}
                        type = "classic"
                        onChange = {cambiaHtml} 
                        config = {configuraciones}
                    />
                </div>
            </Col>
        </Row>
    )

    let respSend = (resp) => {console.log(resp);
        if (resp.tipo === "info") props.funcion()

        NotificationManager[resp.tipo](resp.text);
        setBoton1({ icon: "fa fa-mail-forward", text: "Reenviar", disabled: false })
    }


    let sendMess = () => {
        if (boton1.disabled === true) return null;

        if (destEmail === "" && destinatarios.length === 0){
            NotificationManager.error("Debes tener al menos un destinatario");
            return null;
        }

        if (contentState === "" && asunto === ""){
            setOpenModalConfirm(true)
        }else{
            /* Agregar los adjuntos */
            let adjuntos = []
            attFileName.map(file => {
                adjuntos.push(document.getElementById(file[3]))
            })
            setBoton1({icon: "fa fa-spinner fa-spin", text: "Enviando", disabled: true})
            sendForwardMail (adjuntos, props.Remitente.value, destEmail, destinatarios, asunto, contentState, props.contenido.UId, attFileNameOr, (resp) => {respSend(resp)})
        }
    }

    /* console.log(props.adjuntos);
    console.log(props.contenido.UId); */
    return (
        <React.Fragment>
            <Row style={{paddingLeft: 10, paddingRight: 10}}>
                <div className="custom-alert-info" style={{backgroundColor:"fff", minHeight: 45, boxShadow:"2px 2px 4px #CCC", padding: 5}}>
                    <Row>
                        <Col md={7} xs={12}>
                        <div><i title="Volver al mensaje" onClick={()=> {props.funcion()}} className="fa fa-arrow-circle-left" style={styles2}></i> <strong>Reenviar Mensaje</strong></div>
                            <div className="text-muted" style={{fontSize: 12, paddingLeft: 22}}>De: <strong>{props.Remitente.label}</strong></div>
                        </Col>
                    </Row>
                </div>
            </Row>
            <Row className="custom-mt-10" style={{left: 15, right: 15, position:"absolute", backgroundColor:"fff",
                height: "57vh", overflowY: "auto", overflowX: "hidden", borderTop: "1px solid #ededed", borderBotton: "1px solid #ededed"}}>
                <Col md={9} className="custom-mt-10">
                    {contenidoMail()}
                </Col>
                <Col md={3} className="custom-mt-10" style={{paddingLeft: 0}}>
                    <div style={{backgroundColor:"f2f4f8", boxShadow:"inset 2px 2px 1px #CCC", borderRadius:"4px 4px", padding: 5}}>
                        <div align="center" style={{height: "42vh", overflowY: "auto", overflowX: "hidden"}}>
                            <button className="btn btn-default" onClick={() => {addAttachment((Math.random() * 999999) + 1, (resp) => { addAttState(resp) })}} style={{borderWidth: 0, marginBottom: 5}} title="Haz click aqui para adjuntar un archivo"><i className={boton2.icon}></i> {boton2.text}</button>
                            <div id="attachments"></div>
                            <div style={{borderTop: "1px solid #ccc", paddingTop: 5}} align="left">{adjuntos()}</div>
                        </div>
                        <div style={{fontSize: 10, paddingTop: 4, borderTop: "1px solid #ccc"}} align="right"><strong>Total ({formatBytes(tam)})</strong></div>
                    </div>
                    <div className="custom-mt-10" align="right">
                        <button className="btn btn-primary" disabled={boton1.disabled} onClick = { sendMess } style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ForwardEmail;


// WEBPACK FOOTER //
// ./src/views/Email/ForwardEmail.jsx